import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import FilterTableHeader from './FilterTableHeader';


class FilterTable extends Component {
  getDowloadExcel = () => {
      const { uuid, query } = this.props.premiumSearch;
      const link = `/party/export-xlsx/${uuid}`;

      if (query !== 'parties') {
        return null;
      }
      return (
        <a href={link} className="form-submit"
           style={{ float: "right", marginLeft: '4px' }}>
          <i className="fa  fa-file-excel-o"></i> Download Excel
        </a>
      );
  }
  getAdvancedSearchLink = () => {
    const { uuid, query } = this.props.premiumSearch;
    const link = `/advanced-search?case_uuid=${uuid}&query=${query}&do_search=1`;

    return (
      <a href={link} className="advanced-search-link processed">
        Premium Search
      </a>
    );
  }

  changeText = (e) => {
    e.persist();
    this.filterTable(e);
  }

  filterTable = _.debounce((e) => {
    // TODO see if the TextHighlight component can be used here instead
    const searchString = this.props.keyword
      ? this.props.keyword.toLowerCase()
      : _.get(e, 'target.value', '').toLowerCase();

    const words = searchString.split(' ').filter(p => p !== '').reverse();

    window.$('.filter-table tbody tr').removeHighlight();

    window.$('.filter-table tbody tr:not(.no-filter-search)').each((index, tableRow) => {
      if (_.every(words, p => window.$(tableRow).text().toLowerCase().indexOf(p) > -1)) {
        tableRow.style.display = '';
        words.forEach((word) => {
          if (window.$(tableRow).text().toLowerCase().indexOf(word) > -1) {
            window.$(tableRow).highlight(word);
          }
        });
      } else {
        tableRow.style.display = 'none';
      }
    });
  }, 400);

  render() {
    const { children } = this.props;
    const tableRef = 'case-tbody';
    const advancedSearchLink = (this.props.premiumSearch)
      ? this.getAdvancedSearchLink()
      : null;
    const getDowloadExcel = (this.props.premiumSearch)
      ? this.getDowloadExcel()
      : null;

    return (
      <div className="filter-table" ref={tableRef}>
        <FilterTableHeader
          changeText={this.changeText}
          advancedSearchLink={advancedSearchLink}
          getDowloadExcel={getDowloadExcel} />
        <div className="filter-table-children">
          { children }
        </div>
      </div>
    );
  }
}

FilterTable.defaultProps = {
  premiumSearch: null,
  keyword: '',
};

FilterTable.propTypes = {
  children: PropTypes.node.isRequired,
  premiumSearch: PropTypes.object,
  keyword: PropTypes.any,
};

export default FilterTable;



// WEBPACK FOOTER //
// ./src/components/common/FilterTable.js